import axios from "axios"
const base = "/api/contract-workspace"
const headers = () => ({ Authorization: localStorage.getItem("token") })
const path = id => "/agreements/" + encodeURIComponent(id)
function call(method, url, data) { return axios({ method, url: base + url, data, headers: headers() }).then(response => response.data) }
export function operationId() { return "office-" + Date.now().toString(36) + "-" + Array.from(window.crypto.getRandomValues(new Uint32Array(4))).map(value => value.toString(16)).join("") }
async function download(url, name) {
  const response = await axios({ method: "get", url: base + url, headers: headers(), responseType: "blob" })
  const address = URL.createObjectURL(response.data), link = document.createElement("a")
  link.href = address; link.download = name; link.click()
  window.setTimeout(() => URL.revokeObjectURL(address), 60000)
}
export default {
  action: (id, body) => call("post", path(id) + "/actions", body),
  complete: (id, body) => call("post", path(id) + "/complete", body),
  invoices: (id, body) => call("post", path(id) + "/invoices", body),
  cancelInvoices: (id, body) => call("post", path(id) + "/invoices/cancel", body),
  payment: (id, body) => call("post", path(id) + "/payments", body),
  delivery: (id, body) => call("post", path(id) + "/delivery", body),
  document: id => download(path(id) + "/document", "Vertrag-" + id + ".pdf"),
  invoiceDocument: (id, invoice) => download(path(id) + "/invoices/" + encodeURIComponent(invoice.id) + "/document", invoice.number + ".pdf"),
  settings: studioId => call("get", "/office/settings/" + encodeURIComponent(studioId)),
  saveSettings: (studioId, body) => call("put", "/office/settings/" + encodeURIComponent(studioId), body),
  camtPreview: xml => call("post", "/invoices/camt/preview", { xml }),
  camtConfirm: body => call("post", "/invoices/camt/confirm", body),
  tacOptions: id => call("get", path(id) + "/tac/options"),
  tacProfileSearch: (id, body) => call("post", path(id) + "/tac/profile/search", body),
  tacProfileAssign: (id, body) => call("post", path(id) + "/tac/profile/assign", body),
  tacProfileCreate: (id, body) => call("post", path(id) + "/tac/profile/create", body),
  tacPreview: (id, body) => call("post", path(id) + "/tac/preview", body),
  tacSubmit: (id, body) => call("post", path(id) + "/tac/submit", body),
  tacReconcile: (id, body) => call("post", path(id) + "/tac/reconcile", body),
  tacCredit: (id, body) => call("post", path(id) + "/tac/credit", body),
  tacCreditReconcile: (id, body) => call("post", path(id) + "/tac/credit/reconcile", body),
}
